import { render, staticRenderFns } from "./DoAllocationOrderIn.vue?vue&type=template&id=213e8b57&scoped=true"
import script from "./DoAllocationOrderIn.vue?vue&type=script&lang=js"
export * from "./DoAllocationOrderIn.vue?vue&type=script&lang=js"
import style0 from "./DoAllocationOrderIn.vue?vue&type=style&index=0&id=213e8b57&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "213e8b57",
  null
  
)

export default component.exports